module.exports = __webpack_public_path__ + "img/1491088065.529f48e9.jpg";